import React from "react";
import { Col, Row, Button, Form, Alert } from "react-bootstrap";
import { rankAndCategorizeVoices } from "../utils/SpeechUtils";
import { isMacOSOrWindowsNonEdge } from "../utils/BrowserUtils";
import CustomSlider from "./CustomSlider";
import "./AudioTab.css";

class AudioTab extends React.Component {
  constructor(props) {
    super(props);
    // create a new synth instance
    this.synth = window.speechSynthesis;

    this.state = {
      voiceGroups: {
        highQuality: [],
        standard: [],
        other: [],
      },
    };

    // Bindings
    this.handlePlaySampleClicked = this.handlePlaySampleClicked.bind(this);

    // "Play Sample" button text
    this.sampleText = "The quick brown fox jumps over the lazy dog.";
  }

  async componentDidMount() {
    const voiceGroups = await rankAndCategorizeVoices(
      this.props.voices,
      [window.navigator.language, this.props.language],
      "en",
    );
    this.setState({ voiceGroups });
  }

  handlePlaySampleClicked(selectedVoiceUri) {
    this.props.onVoiceSampleRequested && this.props.onVoiceSampleRequested();

    // create a new utterance
    const sampleUtterance = new SpeechSynthesisUtterance(this.sampleText);

    // get the voice and rate settings
    sampleUtterance.voice = this.synth
      .getVoices()
      .find((f) => f.voiceURI === selectedVoiceUri);
    sampleUtterance.rate = this.props.audioSpeed;

    // voice the sample
    this.synth.speak(sampleUtterance);
  }

  render() {
    const { highQuality, standard, other } = this.state.voiceGroups;
    const allVoices = [...highQuality, ...standard, ...other];

    const renderOptions = (voices) =>
      voices?.map((f) => (
        <option value={f.voiceURI} key={f.voiceURI}>
          {f.name}
        </option>
      ));

    const useGroups =
      [highQuality, standard, other].filter((g) => g.length > 0).length >= 2;

    const selectedVoiceUri = (
      allVoices.find((f) => f.voiceURI === this.props.voice) || allVoices[0]
    )?.voiceURI;
    const voiceMenuLabel = "voiceMenuLabel";

    return (
      <>
        <Row>
          {isMacOSOrWindowsNonEdge() && (
            <Col xs={12}>
              <small>
                For the best voice quality, try opening Bookshare Reader in
                Microsoft Edge, which includes high-quality natural voices.
              </small>
            </Col>
          )}
        </Row>
        <Row className="voice-row">
          <Col xs={12} sm={3}>
            <div className="setting-header">
              <strong id={voiceMenuLabel}>Voice</strong>
            </div>
          </Col>
          <Col xs={12} sm={9} className="voice-dropdown-col">
            <div className="voice-select-wrapper">
              <select
                className="voice-dropdown"
                value={selectedVoiceUri}
                onChange={(evt) => this.props.onVoiceSelect(evt.target.value)}
                aria-labelledby={voiceMenuLabel}
              >
                {useGroups ? (
                  <>
                    {highQuality.length > 0 && (
                      <optgroup role="group" label="High Quality">
                        {renderOptions(highQuality)}
                      </optgroup>
                    )}
                    {standard.length > 0 && (
                      <optgroup role="group" label="Standard">
                        {renderOptions(standard)}
                      </optgroup>
                    )}
                    {other.length > 0 && (
                      <optgroup role="group" label="Other">
                        {renderOptions(other)}
                      </optgroup>
                    )}
                  </>
                ) : (
                  renderOptions(allVoices)
                )}
              </select>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          {this.props.isGoogleVoice && (
            <Col xs={12}>
              <Alert variant="warning">
                Google voices sound more natural but do not support word-by-word
                highlighting. Sentence highlighting is still available.
              </Alert>
            </Col>
          )}
        </Row>
        <br />
        <Row>
          <Col>
            <CustomSlider
              name="audioSpeed"
              label="Audio Speed"
              value={this.props.audioSpeed}
              options={this.props.audioSpeedOptions}
              onChange={this.props.onAudioSpeedChange}
              incrementButtonLabel={"Increase Audio Speed"}
              decrementButtonLabel={"Decrease Audio Speed"}
              defaultButtonLabel={"Set to Normal Speed"}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={{ offset: 4 }} className="play-sample-button-col">
            <Button
              className="play-sample-button"
              onClick={() => {
                this.handlePlaySampleClicked(selectedVoiceUri);
              }}
              aria-label="Play Voice Sample"
            >
              <Row>
                <Col>Play Sample</Col>
              </Row>
            </Button>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={3}>
            <div className="setting-header">
              <strong>Voicing Options</strong>
            </div>
          </Col>
          <Col xs={12} sm={9}>
            <Form.Check
              type="checkbox"
              checked={this.props.voicePageNumbers}
              label="Voice Page Numbers"
              onChange={(evt) =>
                this.props.onVoicePageNumberChange(evt.target.checked)
              }
              id="voice_page_numbers_checkbox"
            />
            <Form.Check
              type="checkbox"
              checked={this.props.voiceImageDescriptions}
              label="Voice Image Descriptions"
              onChange={(evt) =>
                this.props.onVoiceImageDescriptionChange(evt.target.checked)
              }
              id="voice_image_descriptions_checkbox"
            />
          </Col>
        </Row>
        <br />
      </>
    );
  }
}

export default AudioTab;
